import React from 'react';

const EventContainer = ({ title, createdAt, onClick }) => {
    return (
        <div className="py-4 px-2 cursor-pointer" onClick={onClick}>
            <div className="text-base font-medium">{title}</div>
            <div className="text-sm text-gray-500">{new Date(createdAt).toLocaleDateString('ko-KR')}</div>
        </div>
    );
};

export default EventContainer;
